import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=755a1165&scoped=true&"
import script from "./ProcessTPRB.vue?vue&type=script&lang=js&"
export * from "./ProcessTPRB.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=755a1165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a1165",
  null
  
)

export default component.exports